const initialState = {};

export default function plpTopBannerReducer(state = initialState, action) {
  const { type = '', data = {} } = action || {};
  switch (type) {
    case 'GET_PLP_TOP_BANNER_SUCCESS':
      return { ...state, ...data };
    case 'GET_PLP_TOP_BANNER_ERROR':
      return { ...state, ...data };
    default:
      return state;
  }
}
